import React from 'react'
import { compose } from 'recompose'
import { connect } from 'react-redux'
import { push } from 'connected-react-router'
import isEqual from 'lodash/isEqual'

import { analyticsActions, wizardActions } from '../../redux'
import { ReduxState } from '../../types'
import { WizardSteps, WizardStep } from '../../constants/wizard'

interface Props {
  actualStep: WizardStep
  pathname: string
  ComposedComponent: any
  push: Function
  setActualStep: any
  setAnalyticsPage: any
  setCompleted: any
  setUncompleted: any
  steps: WizardSteps
  stepsHistory: string[]
}

export type WizardInt = {
  gotoNext: () => void
  gotoPrevious: () => void
}

export interface WizardInterface {
  wizard: WizardInt
}

export class Wizard extends React.Component<Props> {
  constructor(props: Props) {
    super(props)

    const actualStepName = this.props.pathname

    const actualStep: WizardStep = props.steps[actualStepName]

    if (actualStep && !isEqual(actualStep, props.actualStep)) {
      props.setActualStep(actualStep)

      // send to analytics
      props.setAnalyticsPage(actualStepName)
      // This helps to prevent browser back button
      props.push(actualStepName)
    } else if (!actualStep) {
      props.push('/')
    }
  }

  gotoNext = () => {
    const actualStepName = this.props.pathname
    if (this.props.actualStep && this.props.actualStep.next) {
      this.props.setCompleted(actualStepName)
      this.props.push(this.props.actualStep.next())
    }
  }

  gotoPrevious = () => {
    const actualStepName = this.props.pathname
    if (this.props.actualStep && this.props.actualStep.prev) {
      this.props.setUncompleted(actualStepName)
      this.props.push(this.props.actualStep.prev())
    }
  }

  render() {
    const { ComposedComponent, ...props }: any = this.props

    const api: WizardInt = {
      gotoNext: this.gotoNext,
      gotoPrevious: this.gotoPrevious,
    }

    return <ComposedComponent {...props} wizard={api} />
  }
}

/**
 * We're passing ComposedComponent as prop
 * so we can use the Wizard class alone for testing
 */
const enhance = (ComposedComponent: any) =>
  compose(
    connect(
      (state: ReduxState) => ({
        steps: state.wizard.steps,
        actualStep: state.wizard.actualStep,
        stepsHistory: state.wizard.history,
        pathname: state.router.location.pathname,
        ComposedComponent,
      }),
      {
        push,
        setActualStep: wizardActions.setActualStep,
        setAnalyticsPage: analyticsActions.setAnalyticsPage,
        setCompleted: wizardActions.setCompleted,
        setUncompleted: wizardActions.setUncompleted,
      }
    )
  )(Wizard)

export default enhance
